import { responsiveFontSizes } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import shadows from './shadows';
import { light, dark } from './palette';

const getTheme = (mode, themeToggler) =>
    responsiveFontSizes(
        createTheme({
            palette: mode === 'dark' ? dark : light,
            shadows: shadows(mode),
            typography: {
                fontFamily: '"Lato", sans-serif',
                button: {
                    textTransform: 'none',
                    fontWeight: 'medium',
                },
            },
            zIndex: {
                appBar: 1200,
                drawer: 1300,
            },
            components: {
                MuiButton: {
                    styleOverrides: {
                        root: {
                            fontWeight: 400,
                            borderRadius: 5,
                            paddingTop: 10,
                            paddingBottom: 10,
                        },
                        containedSecondary: mode === 'light' ? { color: 'white' } : {},
                    },
                },
                MuiInputBase: {
                    styleOverrides: {
                        root: {
                            borderRadius: 5,
                        },
                    },
                },
                MuiOutlinedInput: {
                    styleOverrides: {
                        root: {
                            borderRadius: 5,
                        },
                        input: {
                            borderRadius: 5,
                        },
                    },
                },
                MuiCard: {
                    styleOverrides: {
                        root: {
                            borderRadius: 8,
                        },
                    },
                },
                MuiCssBaseline: {
                    styleOverrides: (theme) => {
                        const tokens = theme.palette.libretto || {};
                        return {
                            ':root': {
                                '--app-bg-canvas': tokens.bgCanvas || '#F5F6F7',
                                '--app-bg-surface': tokens.bgSurface || '#FFFFFF',
                                '--app-bg-subtle': tokens.bgSubtle || '#F3F4F6',
                                '--app-border-subtle': tokens.borderSubtle || '#E5E7EB',
                                '--app-border-muted': tokens.borderMuted || '#D1D5DB',
                                '--app-text-primary': tokens.textPrimary || '#1A1A1A',
                                '--app-text-muted': tokens.textMuted || '#6B7280',
                                '--app-text-subtle': tokens.textSubtle || '#9CA3AF',
                                '--app-icon-primary': tokens.iconPrimary || '#4B5563',
                            },
                            html: {
                                backgroundColor: 'var(--app-bg-canvas)',
                            },
                            body: {
                                backgroundColor: 'var(--app-bg-canvas)',
                                color: 'var(--app-text-primary)',
                            },
                            '#root': {
                                backgroundColor: 'var(--app-bg-canvas)',
                                color: 'var(--app-text-primary)',
                            },
                        };
                    },
                },
                MuiPaper: {
                    styleOverrides: {
                        root: {
                            backgroundColor: 'var(--app-bg-surface)',
                            color: 'var(--app-text-primary)',
                        },
                    },
                },
                MuiDialog: {
                    styleOverrides: {
                        paper: {
                            backgroundColor: 'var(--app-bg-surface)',
                            color: 'var(--app-text-primary)',
                            border: '1px solid var(--app-border-subtle)',
                        },
                    },
                },
                MuiMenu: {
                    styleOverrides: {
                        paper: {
                            backgroundColor: 'var(--app-bg-surface)',
                            color: 'var(--app-text-primary)',
                            border: '1px solid var(--app-border-subtle)',
                        },
                    },
                },
                MuiPopover: {
                    styleOverrides: {
                        paper: {
                            backgroundColor: 'var(--app-bg-surface)',
                            color: 'var(--app-text-primary)',
                            border: '1px solid var(--app-border-subtle)',
                        },
                    },
                },
            },
            breakpoints: {
                values: {
                    xs: 0,
                    sm: 600,
                    smd: 1050,
                    md: 1150,
                    lmd: 1280,
                    lg: 1300,
                    xl: 1536,
                },
            },
            themeToggler,
        }),
    );

export default getTheme;
